import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { getApprovals } from 'src/core/store/ducks/approvals/actions'
import currencyMask from 'src/components/Formik/InputCurrency/mask'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from '../styles'
import Header from '../components/Header'
import StatusFilter from '../../components/StatusFilter'
import Table, { DataSource } from '../../components/Table'

export default function Approvals() {
  useDocumentTitle('web.side.approvals')
  const { approvals } = useSelector((state: ApplicationState) => ({
    approvals: state.approvals
  }))
  const dispatch = useDispatch()

  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    dispatch(getApprovals({ filterStatus: approvals.filterStatus, page: 1 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      approvals.list.map(
        ({
          approvers,
          cost,
          request_approvals,
          request_id,
          request_number,
          requested_on,
          status,
          sync_status,
          title
        }) => ({
          approvers,
          cost: currencyMask({ formatStr: true, value: cost }).maskedValue,
          extra: {
            request_approval_id: request_approvals[0].request_approval_id
          },
          id: request_id,
          key: request_id,
          number: request_number,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          sync_status,
          title,
          users: request_approvals.map(({ request_user_data, status }) => ({
            gender: request_user_data.traveler.gender,
            name: request_user_data.traveler.name,
            reason: request_user_data.reason,
            status,
            user_id: request_user_data.traveler.user_id
          }))
        })
      )
    )
  }, [approvals.list])

  return (
    <>
      <Header error={approvals.error} title="web.side.approvals" />
      <CSS.HeaderFilters>
        <StatusFilter
          defaultValue={approvals.filterStatus}
          onChange={values => {
            dispatch(getApprovals({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={['pending', 'approved', 'canceled', 'reproved', 'expired']}
        />
      </CSS.HeaderFilters>
      <Table
        approvals
        currentPage={currentPage}
        dataSource={list}
        loading={approvals.loading}
        onChange={page => {
          dispatch(getApprovals({ filterStatus: approvals.filterStatus, page }))
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => ({
          onClick: () =>
            history.push(
              `/approvals/${record.extra.request_approval_id}/request/${record.id}`
            )
        })}
        totalPages={approvals.total_results}
      />
    </>
  )
}
